import { combineReducers } from 'redux';
import authReducer from './authReducer';
import businessDataReducer from './businessDataReducer';

export default combineReducers({
    auth:authReducer,
    businessData:businessDataReducer
})